import { ThunkResult } from '../../../stores/types';

function use(...args: unknown[]) {
  return args;
}

function fetchPriceBookExportTypes(_organization: string): ThunkResult<Promise<void>> {
  return (
    _dispatch,
    _getState,
    _extra,
  ) => {
    use(_organization, _dispatch, _getState, _extra);
    return Promise.resolve();
  };
}

export default fetchPriceBookExportTypes;
